import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'
import React from 'react'

import RichText from '@/theme/components/RichText'

export const Message: React.FC<{ message: DefaultTypedEditorState }> = ({ message }) => {
  return message ? <RichText data={message} enableProse={false} /> : null
}
